import React from 'react';
import { ATTENDANCE_STATUS_STYLES, statusLabel } from './attendanceStatus';
import { cn } from '../../../lib/utils';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function AttendanceCalendarGrid({ days = [], onDayClick }) {
  const firstWorking = days.find((d) => !d.empty && d.date);
  const padStart = firstWorking?.date
    ? new Date(`${firstWorking.date}T12:00:00`).getDay()
    : 0;

  const cells = [];
  for (let i = 0; i < padStart; i += 1) {
    cells.push({ key: `pad-${i}`, empty: true, pad: true });
  }
  days.forEach((d) => {
    if (!d.empty) cells.push(d);
  });

  return (
    <div>
      <div className="grid grid-cols-7 gap-1 mb-1">
        {WEEKDAYS.map((w) => (
          <div key={w} className="text-center text-xs font-medium text-muted-foreground py-1">
            {w}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((day) => {
          if (day.pad) {
            return <div key={day.key} className="aspect-square" />;
          }
          if (day.empty) {
            return <div key={`e-${day.day}`} className="aspect-square" />;
          }
          const st = day.display_status || 'empty';
          const style = ATTENDANCE_STATUS_STYLES[st] || ATTENDANCE_STATUS_STYLES.empty;
          const label = statusLabel(st);
          const events = day.school_events || [];
          const eventTitles = events.map((e) => e.title).filter(Boolean);
          const tooltipParts = [day.date];
          if (label) tooltipParts.push(label);
          if (eventTitles.length) tooltipParts.push(eventTitles.join(', '));
          const eventLine = eventTitles.length
            ? (eventTitles.length === 1 ? eventTitles[0] : `${eventTitles[0]} +${eventTitles.length - 1}`)
            : null;
          return (
            <button
              key={day.date}
              type="button"
              onClick={() => onDayClick?.(day)}
              className={cn(
                'aspect-square rounded-md border text-xs flex flex-col items-center justify-center gap-0.5 py-0.5',
                'transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ring',
                style,
              )}
              title={tooltipParts.join(' — ')}
            >
              <span className="font-semibold shrink-0">{day.day}</span>
              {label ? (
                <span className="text-[8px] sm:text-[9px] leading-tight text-center px-0.5 max-w-full line-clamp-1 opacity-80">
                  {label}
                </span>
              ) : null}
              {eventLine ? (
                <span className="text-[7px] sm:text-[8px] leading-tight text-center px-0.5 max-w-full line-clamp-1 opacity-70 font-medium">
                  {eventLine}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
